import { SessionType, Dictation } from '../../_interfaces/dictation';

export const RESUME_CONSULTATION_FLAG = 'resumeConsultation';

export function hasDocumentsToUpdate(dictation: Dictation | null | undefined): boolean {
  const processed = dictation?.copilot?.documents?.processed ?? [];
  return processed.length > 0;
}


export function isResumeOriginAllowed(dictation: Dictation | null | undefined): boolean {
  if (!dictation) return false;
  if (dictation.type === 'backend') return false;

  const sessionType = dictation.copilot?.type;
  if (sessionType === SessionType.Upload || sessionType === SessionType.Dictation) return false;
  if (sessionType === SessionType.Encounter) return true;

  const hasStoredTranscription = !!dictation.copilot?.transcription?.trim();
  if (hasDocumentsToUpdate(dictation) && !hasStoredTranscription) {
    return false;
  }

  return true;
}

export function isResumeEligible(
  dictation: Dictation | null | undefined,
  featureEnabled: boolean
): boolean {
  if (!featureEnabled || !dictation) return false;
  return isResumeOriginAllowed(dictation);
}

export function isResumedConsultation(dictation: Dictation | null | undefined): boolean {
  return hasDocumentsToUpdate(dictation);
}
